import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import { AnimatePresence } from 'framer-motion';
import { ThemeContext } from './context/ThemeContext';

const MobileNavBar = () => {

    const { darkMode } = useContext(ThemeContext);

    return (
        <AnimatePresence>
            <motion.div className={`${darkMode ? '' : ''} backdrop-blur-md border border-black p-3 rounded z-50 left-0 right-0 top-16 fixed mx-8 lg:hidden`}
                initial={{ y: -150, opacity: 0, }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: -150 }}
                transition={{ duration: 0.8, type: 'spring' }}

            >
                <ul className='flex flex-col gap-4'>
                    <a href='#home'>Home</a>
                    <a href='#about'>About</a>
                    <a href='#works'>Works</a>
                    <a href='#contact'>Contact</a>
                </ul>
            </motion.div>


        </AnimatePresence>
    );
}

export default MobileNavBar;